import { EngineMeasurementControllerService } from 'shared/api/generatedApi/services/EngineMeasurementControllerService';
import { EngineMeasurementRequestDto } from 'shared/api';

export const engineMeasurementApi = {
  getEngineMeasurementById: (id: number) => EngineMeasurementControllerService.findEngineMeasurementById(id),
  createEngineMeasurement: (data: EngineMeasurementRequestDto) => EngineMeasurementControllerService.createEngineMeasurement(data),
  deleteEngineMeasurement: (id: number) => EngineMeasurementControllerService.deleteEngineMeasurement(id),
  getEngineMeasurements: (
    engineId?: number,
    from?: string,
    to?: string,
  ) => EngineMeasurementControllerService.findEngineMeasurements(engineId, from, to),
  updateEngineMeasurement: (
    id: number,
    data: EngineMeasurementRequestDto,
  ) => EngineMeasurementControllerService.updateEngineMeasurement(id, data),
};
